import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function ContactCtaSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  return (
    <section id="contact-cta" className="bg-navy py-16 md:py-24">
      <div ref={ref} className="w-full px-4 md:px-8 max-w-4xl mx-auto text-center">
        <h2
          className={`text-2xl md:text-4xl font-bold text-white leading-relaxed mb-4 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          警備のご依頼・お見積もりはお気軽に
        </h2>
        <p
          className={`text-base md:text-lg text-gray-300 leading-relaxed mb-10 transition-all duration-1000 delay-150 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          まずはお電話またはメールフォームよりご連絡ください。<br className="hidden md:block" />
          最短即日でご対応いたします。
        </p>

        <div
          className={`bg-white/10 rounded-2xl inline-flex items-center gap-4 px-8 py-5 md:px-12 md:py-6 mb-8 transition-all duration-1000 delay-300 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="w-8 h-8 flex items-center justify-center text-gold">
            <i className="ri-phone-line text-2xl"></i>
          </span>
          <div className="text-left">
            <p className="text-sm text-gray-300">TEL</p>
            <a
              href="tel:08045635272"
              className="text-3xl md:text-5xl font-black text-white hover:underline block whitespace-nowrap"
            >
              080-4563-5272
            </a>
          </div>
        </div>

        <div
          className={`transition-all duration-1000 delay-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 bg-[#E47911] text-white font-bold text-base md:text-lg px-8 py-4 rounded-full transition-all duration-300 hover:bg-[#E47911]/90 hover:scale-105 whitespace-nowrap"
          >
            お問い合わせフォームへ
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}